import React from 'react';
import Navbar from './components/Navbar';
import {Container, Content} from './styles';

const DefaultLayout = ({children}) => (
  <Container>
    <Navbar />
    <Content>
      {children}
    </Content>
  </Container>
);

export default DefaultLayout;